import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Button} from "primeng/button";
import {TranslatePipe} from "@ngx-translate/core";
import {SipoService} from "../../services/SipoService";
import {log} from "@angular-devkit/build-angular/src/builders/ssr-dev-server";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {SignerModel} from "../../model/signer-model";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-cancel-sign-confirmation-modal',
    standalone: true,
    imports: [
        Button,
        TranslatePipe,
        NgIf
    ],
    templateUrl: './cancel-sign-confirmation-modal.component.html',
    styleUrl: './cancel-sign-confirmation-modal.component.scss'
})
export class CancelSignConfirmationModalComponent {

    @Input() signerModel!: SignerModel;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
        this.signerModel = this.config.data.signerModel
    }

    emitState(closingState: boolean, saveAsDraft: boolean) {
        const stateObj = {
            close: closingState,
            saveAsDraft: saveAsDraft
        }
        this.ref.close(stateObj);
    }

}
